import { BoxProps } from '@mui/material';
import { RootState, useSelector } from 'redux/store';

import { CustomTheme } from 'enums/customeTheme';
import DostSageLogo from 'assets/logo/DostSageLogo.svg';
import newDostLogo from '../assets/logo/newDostLogo.png';
import DostLogo from '../assets/logo/newDostLogoWithoutText.png';

interface ILogoProps extends BoxProps {
  disabledLink?: boolean;
  isCollapse?: boolean;
  isDrawer?: boolean;
}

export default function Logo({ disabledLink = false, isCollapse, isDrawer = false }: ILogoProps) {
  const customTheme = useSelector((state: RootState) => state.customer.customer?.customTheme);
  const showSageBranding = customTheme === CustomTheme.Sage && !isCollapse && isDrawer;
  const logo = isCollapse ? (
    <img src={DostLogo} alt="Dost Logo" height={'44px'} width={'44px'} />
  ) : (
    <img
      src={showSageBranding ? DostSageLogo : newDostLogo}
      alt="Dost Logo"
      style={{ width: showSageBranding ? '180px' : '100px' }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <>{logo}</>;
}
